import React, { useEffect } from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { formatDate, formatReceiptDate } from "../../../utils/formatNocDate";
import BharatNetAgreement from "./BharatNetAgreement";
import ROWProvisionalFinalAgreement from "./ROWProvisionalFinalAgreement";

const RowOfcProvisional = ({
  feeDetails,
  getFeesDetails,
  userData,
  applicantdata,
  roDetails,
  bgDetails,
  paDetails,
}: any) => {
  console.log("feeDetails", feeDetails);
  console.log("getFeesDetails", getFeesDetails);
  const { application_code } = applicantdata || {};

  return (
    <>
      <style>
        {`
          @page {
            size: A4;
            margin: 8mm 10mm;
          }

          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            height: auto !important;
            overflow: visible !important;
          }

          .pdf-document {
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            color: #000 !important;
          }

          .pdf-agreement-page {
            display: block !important;
            break-before: page !important;
            page-break-before: always !important;
            break-inside: auto !important;
            page-break-inside: auto !important;
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
          }

          @media print {
            .pdf-agreement-page,
            .html2pdf__page-break {
              display: block !important;
              break-before: page !important;
              page-break-before: always !important;
              break-inside: auto !important;
              page-break-inside: auto !important;
            }

            .pdf-document > .MuiPaper-root {
              break-inside: auto !important;
              page-break-inside: auto !important;
              overflow: visible !important;
            }
          }
        `}
      </style>
      <Box
        className="pdf-document"
        sx={{
          p: { xs: 1, md: 4 },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          margin: "0 auto",
          overflow: "visible",
          height: "auto",
          minHeight: 0,
          textAlign: "justify",
          fontSize: 18,
          fontFamily: "Trebuchet MS, Arial, sans-serif !important",
          "& *": {
            fontFamily: "Trebuchet MS, Arial, sans-serif !important",
          },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, md: 4 },
            borderRadius: 3,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            height: "auto",
            minHeight: 0,
            overflow: "visible",
            "@media print": {
              boxShadow: "none",
              borderRadius: 0,
              padding: 0,
              overflow: "visible",
            },
          }}
        >
          <img
            src={require("@assets/images/national-emblem.png")}
            alt="National Emblem"
            style={{
              display: "block",
              margin: "0 auto",
              width: 60,
              height: "auto",
            }}
          />
          <Typography
            variant="h6"
            fontWeight={700}
            align="center"
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Government of India
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Ministry of Road Transport & Highways
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Regional Office - {roDetails?.office_name || "____"}
          </Typography>
          {/* <Typography align="center" sx={{ fontWeight: 400, fontSize: "inherit" }}>
          {roDetails?.address_line1 || "____"}
        </Typography>
        <Typography align="center" sx={{ fontWeight: 400, fontSize: "inherit" }}>
           Phone No. {roDetails?.contact_number || "____"} ,
          Email-
          {roDetails?.email ? (
            <a href={`mailto:${roDetails.email}`}>{roDetails.email}</a>
          ) : (
            "____"
          )}
        </Typography>*/}
          <Divider sx={{ my: 2 }} />

          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              mb: 1,
              textDecoration: "underline",
              textAlign: { xs: "right", md: "right" },
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            PROVISIONAL NOC
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Application No.: <b>{application_code || "_____"}</b>
            </Typography>
            <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Dated: <b>{formatDate(new Date().toISOString())}</b>
            </Typography>
          </Box>
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            To,
            <br />
            {/* {userData?.name || "_____"},
          <br /> */}
            {userData?.organizations?.[0]?.business_name || "____"}
            <br />
            {userData?.organizations?.[0]?.city_name || "____"},&nbsp;
            {userData?.organizations?.[0]?.district_name || "____"},&nbsp;
            {userData?.organizations?.[0]?.state_name || "____"}
            <br />
            {userData?.organizations?.[0]?.pincode || " "}
          </Typography>
          {/* Subject */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Subject:</b> Permission for accommodation of{" "}
            <b>{applicantdata?.amenity}</b>{" "}
            <b>{applicantdata?.proposed_utility_alignment}</b>&nbsp;
            <b>{applicantdata?.national_highway_number}</b> regarding issue of
            Final NOC.
          </Typography>

          {/* Body */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Respected Sir/Mam,
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;Please refer to your application id{" "}
            <b>{application_code || "<id No>"}</b> dated{" "}
            <b>{formatDate(applicantdata?.created_at) || "<date>"}</b>{" "}
            submitting therewith proposal for accommodation of subject cited
            utility services for approval of this office.
            <br />
            2. The licensee fee submission as submitted by{" "}
            <b>
              {userData?.organizations?.[0]?.business_name ||
                "____" ||
                "<organization name>"}
            </b>{" "}
            has been received by the Government.
            <br />
            3. You have proposed for Proposal of permission for{" "}
            <b>{applicantdata?.amenity || "NA"}</b>, which have also been
            recommended by the{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            . You have submitted requisite license fees of ₹{" "}
            <b>
              {feeDetails?.[0]?.fees?.totalAmount ||
                getFeesDetails?.finalLicenseFees ||
                "0"}
            </b>{" "}
            through Bharatkosh Portal dated{" "}
            <b>
              {feeDetails?.[0]?.transactionDate &&
                formatReceiptDate(feeDetails?.[0]?.transactionDate)}
            </b>{" "}
            {feeDetails?.[0]?.transactionId &&
              "Transaction Ref No -" +
                (feeDetails?.[0]?.transactionId || "N/A")}
            .
            <br />
            4. Based on the drawings, checklist and associated documents as
            recommended by the{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            , the Permission for use of Highway Land is hereby granted by the
            Regional Officer <strong>{roDetails?.office_name}</strong>, on
            behalf of the Highway Administration as per details indicated in the
            approved drawing and the conditions stipulated below in the license
            deed. A signed copy of the license deed is enclosed for necessary
            action. This license deed for the instant Utility Service is valid
            for 5 years from the date of issue of this permission. On the expiry
            of lease, the permission may be renewed by the Highway
            Administration on payment of applicable renewal fee, if it conforms
            to the stipulated norms of the Ministry. The Utility Service
            provider shall apply, with all the documents, for renewal at least
            four months before the expiry of license deed. The Permission is
            being issued to the proposal, subject to the following general
            conditions:
          </Typography>

          {/* General Conditions */}
          <Box
            component="ol"
            sx={{
              pl: 3,
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              listStyleType: "none",
              counterReset: "item",
              "& > li": {
                counterIncrement: "item",
                "&::before": {
                  content: '"4." counter(item) " "',
                  fontWeight: "normal",
                  marginRight: "0.5em",
                },
              },
            }}
          >
            <li>
              The accommodation of proposed utility shall be strictly as per the
              Ministry’s letter No.RW/NH-33044/29/2015/S&R(R) dated 22.11.2016
              and as per the details indicated in the approved
              sketches/drawings. No change in the alignment of other than
              approved herein will be entertained. Any deviation may result in
              cancelling of the permission/approval.
            </li>
            <li>
              The applicant will be authorized to install/laying of the utility
              services as per approved methodology and drawings within the NH
              RoW only after signing of the agreement.
            </li>
            <li>
              The proposed laying operation of utility shall be in such a manner
              that it causes least interference to the traffic movement and also
              traffic safety.
            </li>
            <li>
              RoW permissions are only enabling in nature. The purpose of
              extending the way leave facility on the National Highway RoW is
              not for enhancing the scope of activity of a utility service
              provider, either by content or by intent. Further, enforceability
              of the permission so granted shall be restricted only to the
              extent of provisions/scope of activities defined in the license
              agreement for the purpose for which it is granted.
            </li>
            <li>
              No Licensee shall claim exclusive right on the RoW and any
              subsequent user will be permitted to use the RoW, either above or
              below, or by the side of the utilities laid by the first user,
              subject to technical requirements being fulfilled. Decision of the
              Authority in relation to fulfilment of technical requirements
              shall be final and binding on all concerned parties. In case any
              disruption/damage is caused to any existing user by the subsequent
              user, the Authority shall not be held accountable or liable in any
              manner.
            </li>
            <li>
              The Licensee shall be responsible for undertaking all activities
              including, but not limited to site identification, survey, design,
              engineering, arranging finance, project management, obtaining
              regulatory approvals & necessary clearances, supply of equipment,
              material, construction, erection, testing and commissioning,
              maintenance and operation and all other activities essential or
              required for efficient functioning of their own utility /
              industrial infrastructure facilities.
            </li>
            <li>
              License Fee shall have to be paid in advance for the period for
              which permission is granted for entering into a license agreement.
              In case of renewal, rate prevailing at the time of renewal shall
              be charged. Delay in renewal and deposition of fee shall attract
              interest @ 15% per annum compounded annually.
            </li>
            <li>
              The utility service shall be permitted to cross the National
              Highway either through structure or conduits specially built for
              those purposes. The casing / conduit pipe should, as minimum,
              extend from drain to drain in cuts and toe of slope to toe of
              slope in the fills and shall be designed in accordance with the
              provision of IRC and executed following the Specifications of the
              Ministry. The Existing drainage structures shall not be allowed to
              carry the lines across. The Licensee shall ensure making good the
              excavated trench for laying utility services by proper filling and
              compaction, so as to restore the land in to the same condition as
              it was before digging the trench, clearing debris/loose earth
              produced due to execution of trenching at least 50 m away from the
              edge of the right of way.
            </li>
            <li>
              <span style={{ textDecoration: "underline" }}>
                All required restoration works subsequent to laying of the
                Utility shall be required to be undertaken by the Licensee at
                its own cost either by itself or through its authorized
                representative in consultation with the Authority (The concerned
                Executive Engineer of NH Division Ahmedabad as per predetermined
                time schedule and quality standards.
              </span>
            </li>
            <li>
              <span style={{ textDecoration: "underline", fontWeight: "bold" }}>
                Prior to commencement of any work on the ground, a Performance
                Bank Guarantee of amount ₹{" "}
                <b>{getFeesDetails && getFeesDetails?.BankGuarantee}</b> as
                specified by the{" "}
                {Array.isArray(paDetails) && paDetails.length > 0 && (
                  <b>
                    {paDetails.map((pa: any) => pa.office_name).join(" / ")}
                  </b>
                )}{" "}
                . as per MoRTH circular dated 22.11.2016 with a validity of one
                year initially (extendable if required till satisfactory
                completion of work) shall have to be furnished by the Licensee
                to the Authority/its designated agency (
                {Array.isArray(paDetails) && paDetails.length > 0 && (
                  <b>
                    {paDetails.map((pa: any) => pa.office_name).join(" / ")}
                  </b>
                )}
                ) as a security against improper restoration of ground in terms
                of filling/unsatisfactory compaction damages caused to other
                underground installations/utility services interference,
                interruption, disruption or failure caused thereof to any
                services etc. In case of the Licensee failing to discharge the
                obligation of making good of the excavated trench/other
                restoration work, the Authority shall have a right to make good
                the damages caused by excavation, at the cost of the Licensee
                and recover the amount by for feature of the Bank Guarantee.
              </span>
            </li>
            <li>
              <span style={{ textDecoration: "underline" }}>
                In case, the electronic Performance Bank Guarantee (e-PBG) is
                invoked as mentioned above, the Licensee shall be required to
                replenish and reinstate the required electronic Performance Bank
                Guarantee (e-PBG) within one month of such invoking. In case the
                work contemplated herein is not completed to the satisfaction of
                the Authority, which has granted the permission, within a period
                of 11 months from the date of issue of the Bank Guarantee, the
                Licensee shall either furnish a fresh guarantee or extend the
                guarantee for a further period of one year. Notwithstanding
                this, the Licensee shalt be liable to pay full compensation to
                the aggrieved Authority / its designated agency for any damage
                sustained by them by reason of the exercise of the RoW facility.
              </span>
            </li>
            <li>
              <span style={{ textDecoration: "underline", fontWeight: "bold" }}>
                The Licensee shall shift the utility services within 90 days on
                own cost (or as specified by the respective Authority) from the
                date of issue of the notice by the concerned Authority to shift/
                relocate the utility services, in case it is so required for the
                purpose of improvement/widening of the road/route/highway or
                construction of flyover/bridge and restore the road/land to its
                original condition at his own cost and risk.
              </span>
            </li>
            <li>
              The Licensee shall be responsible to ascertain from the respective
              agency in co-ordination with Authority, regarding the location of
              other utilities / underground installations/facilities etc. The
              Licensee shall ensure the safety and security of already existing
              underground installations/utilities/facilities etc. before
              commencement of the excavation/using the existing cable ducts. The
              Licensee shall procure insurance from a reputed insurance company
              against damages to already existing underground
              installations/utilities/facilities etc.
            </li>
            <li>
              <span style={{ textDecoration: "underline" }}>
                The Licensee shall be solely responsible/liable for full
                compensation/indemnification of concerned agency/aggrieved
                Authority for any direct, indirect or consequential damage
                caused to them/claims or replacements sought for, at the cost
                and risk of the Licensee. The concerned agency in co-ordination
                with Authority shall also have a right make good such
                damages/recover the claims by forfeiture of Bank Guarantee.
              </span>
            </li>
            <li>
              Three copies of 'as laid drawings' of utilities (hard and soft
              copies) with geotagged photographs and geo-tagged video recordings
              of laying of cables in the trench (with respect to the NH) and
              after complete restoration shall be submitted to the Authority for
              verification and submitting their recommendation for issuing the
              Final NOC by Highway Administration for making utility
              operational.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                The Utility Services shall not be made operational by the
                Licensee unless a final approval is obtained from the Highway
                Administration without which the concerned Executive Engineer
                will not release the submitted electronic Performance Bank
                Guarantee (e-PBG).
              </span>
            </li>
            <li>
              For PPP Projects, in case of any financial loss incurred by the
              respective project concessionaires due to such laying/shifting of
              utility services by the Licensee, compensation for the same shall
              be required to be borne by the Licensee in mutual agreement with
              the respective project concessionaires. MoRT&H Implementing
              Authorities for the project shall not be liable to the
              concessionaire in any way in this regard.
            </li>
          </Box>
          <br />
          <br />
          <Box>
            <Typography
              sx={{
                mb: 1,
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              <b>Special Instructions of Approval:</b>
            </Typography>
            <Box
              component="ol"
              sx={{
                pl: 0,
                mb: 2,
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              {applicantdata?.ca_provisional_remarks?.comments || "NA"} at{" "}
              {formatDate(applicantdata?.ca_provisional_remarks?.created_at)}
            </Box>
          </Box>

          {/* Special Conditions */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginTop: "2rem",
              marginBottom: "2rem",
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <div style={{ textAlign: "left" }}>
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "inherit",
                  fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                }}
              >
                <b>Encl:</b>
              </Typography>
              <Box
                component="ol"
                sx={{
                  pl: 0,
                  mb: 2,
                  fontSize: "inherit",
                  fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                  listStyle: "none",
                  counterReset: "encl",
                  "& > li": {
                    counterIncrement: "encl",
                    "&::before": {
                      content: '"(" counter(encl, lower-roman) ") "',
                      marginRight: "0.25rem",
                    },
                  },
                }}
              >
                <li>Signed License deed.</li>
                <li>Approved Drawings</li>
              </Box>
            </div>
            <div style={{ marginRight: "1.5rem", textAlign: "right" }}>
              {/* Footer */}
              <Typography
                sx={{
                  mb: 2,
                  ml: 70,
                  fontSize: "inherit",
                  fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                }}
              >
                Yours faithfully,
                <br />
                <b>
                  {roDetails?.ro_name} -{roDetails?.office_name}
                </b>
                <br />
                <b>{applicantdata?.ca_authority}</b>
              </Typography>

              <Typography
                sx={{
                  fontWeight: 700,
                  ml: 70,
                  fontSize: "inherit",
                  fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                }}
              >
                Regional Officer / Executive Director
                <br />
                For Highway Administration
                <br />
                (Digitally signed)
              </Typography>
            </div>
          </div>
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>
              <u>Copy to:</u>{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
            </b>{" "}
            {(applicantdata?.utility_type_id === 5 ||
              applicantdata?.is_legacy) && (
              <span>for information and necessary actions.</span>
            )}
            <br />
            <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              {applicantdata?.utility_type_id !== 5 &&
              !applicantdata?.is_legacy ? (
                <>
                  With request to keep original Bank guarantee vide BG no:{" "}
                  <b>{bgDetails?.bank_guarantee_no || "___"}</b> dated{" "}
                  <b>{formatDate(bgDetails?.bg_isssue_date || "___")}</b> valid
                  up to{" "}
                  <b>{formatDate(bgDetails?.bg_validity_date || "___")}</b> from
                  bank <b>{bgDetails?.bg_bank_name || "___"}</b> in your safe
                  custody.
                </>
              ) : (
                <></>
              )}
            </Typography>
          </Typography>
        </Paper>
        <div
          className="pdf-agreement-page html2pdf__page-break"
          style={{
            display: "block",
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            height: "auto",
            margin: 0,
            padding: 0,
            overflow: "visible",
            breakBefore: "page",
            pageBreakBefore: "always",
            breakInside: "auto",
            pageBreakInside: "auto",
          }}
        >
          {applicantdata?.utility_type_id === 5 ? (
            <BharatNetAgreement
              applicantdata={applicantdata}
              roDetails={roDetails}
              bgDetails={bgDetails}
              paDetails={paDetails}
              getFeesDetails={getFeesDetails}
              feeDetails={feeDetails}
              userData={userData}
            />
          ) : (
            <ROWProvisionalFinalAgreement
              feeDetails={feeDetails}
              applicantdata={applicantdata}
              roDetails={roDetails}
              bgDetails={bgDetails}
              paDetails={paDetails}
              getFeesDetails={getFeesDetails}
              userData={userData}
            />
          )}
        </div>
      </Box>
    </>
  );
};

export default RowOfcProvisional;
